import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Grid, Divider } from "@mui/material";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import MajorFunctions from "../components/MajorFunctions";

export default function PTag() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  //scrolled to top and loading screen
  useEffect(() => {
    window.scrollTo(0, 0);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 200);

    return () => clearTimeout(timer);
  }, []);

  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );
  // 监听窗口大小变化
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const isMobile = windowWidth < 768;

  return (
    <Box sx={{ background: "#FCF8F3", minHeight: "100vh", pt: isMobile ? 12 : 25 }}>
      <Navbar />
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            py: 20,
            minHeight: "100vh",
          }}
        >
          <Typography variant="h6" color="text.secondary">
            <img
              src="https://petpetclub.s3.ap-southeast-1.amazonaws.com/user-uploads/pets/68cb893a0feda12f2dbcc02b/68d4c8ce22baedfbe8b852dd.gif"
              alt="Loading"
              style={{
                width: "150px",
                height: "auto",
                mixBlendMode: "multiply",
              }}
            />
            <div
              style={{
                fontWeight: "500px",
                fontSize: "15px",
                textAlign: "center",
                fontFamily: "Lucida Console",

              }}>
              {t('Loading')}
            </div>
          </Typography>
        </Box>
      ) : (
        <>
          {/* Hero Section */}
          <Box sx={{ maxWidth: 1280, mx: "auto", pt: 6, px: 2 }}>
            <Grid
              container
              spacing={isMobile ? 12 : 24}
              alignItems="center"
              justifyContent="center"
            >
              <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
                <img
                  src="/icons/ptag-2.png"
                  alt="PTag Air"
                  style={{
                    width: 260,
                    height: 260,
                    objectFit: "contain",
                    margin: "0 auto",
                  }}
                />
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  {t('Reference')}
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                sx={{ textAlign: "left" }}
              >
                <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", width: isMobile ? "360px" : "auto" }}>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    25 / 30 {t('mm')}
                  </Typography>
                  <Typography variant="h4" fontWeight={700} sx={{ mb: 1 }}>
                    PTag
                  </Typography>
                  <Typography
                    variant="h5"
                    fontWeight={700}
                    color="#050505"
                    sx={{ mb: 2 }}
                  >
                    HKD $259 {t('up')}
                  </Typography>
                  <Button
                    variant="contained"
                    sx={{
                      background: "#FFB60C",
                      color: "#050505",
                      fontWeight: 700,
                      fontSize: 18,
                      borderRadius: 2,
                      px: 5,
                      py: 1.5,
                      boxShadow: "none",
                      "&:hover": { background: "#FFB60C" },
                    }}
                    onClick={() => {
                      navigate("/ptag/payment");
                    }}
                  >
                    {t('buyNow')}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ width: "100%", mx: "auto", mt: 8, px: 2 }}>
            <Divider sx={{ my: 8 }} />
          </Box>
          <MajorFunctions />
          <Box sx={{ width: "100%", mx: "auto", mt: 8, px: 2 }}>
            <Divider sx={{ my: 8 }} />
          </Box>
          {/* Size Selection Section */}
          <Box
            sx={{
              maxWidth: 1280,
              mx: "auto",
              mt: 8,
              px: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography variant="h4" fontSize={isMobile ? 26 : "auto"} fontWeight={700} sx={{ mb: 2 }}>
              {t('SizeSelection')} 
            </Typography>
            <Box sx={{ fontSize: isMobile ? 12 : 16, mb: 2, mx: 2, textAlign: "left" }}>
              <ul style={{ listStyleType: "disc" }}>
                <li>{t('SmallDog')}</li>
                <li>{t('MediumDog')}</li>
              </ul>
            </Box>
          </Box>

          {/* Product Selection Section */}
          <Box
            sx={{ maxWidth: 700, mx: "auto", mt: 4, mb: 4, textAlign: "center" }}
          >
            <Grid
              container
              spacing={4}
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-around",
              }}
            >
              <Grid item xs={12} sm={6}>
                <Box>
                  <Typography variant="h6" fontWeight={700} sx={{ mt: 2 }}>
                    PTag
                  </Typography>
                  <img
                    src="/icons/ptag-2.png"
                    alt="PTag"
                    style={{
                      width: isMobile ? 140 : 180,
                      height: isMobile ? 140 : 180,
                      objectFit: "contain",
                      margin: "0 auto",
                    }}
                  />
                  <Button
                    variant="contained"
                    sx={{
                      background: "#FFB60C",
                      color: "#050505",
                      fontWeight: 700,
                      fontSize: 16,
                      borderRadius: 2,
                      px: 4,
                      py: 1,
                      mt: 2,
                      boxShadow: "none",
                      "&:hover": { background: "#FFB60C" },
                    }}
                    onClick={() => {
                      navigate("/ptag/payment");
                    }}
                  >
                    {t('buy')}
                  </Button>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box>
                  <Typography variant="h6" fontWeight={700} sx={{ mt: 2 }}>
                    PTag{" "}
                    <span style={{ color: "#2196f3", fontWeight: 400 }}>Air</span>
                  </Typography>
                  <img
                    src="/icons/ptagair-2.png"
                    alt="PTag Air"
                    style={{
                      width: isMobile ? 140 : 180,
                      height: isMobile ? 140 : 180,
                      objectFit: "contain",
                      margin: "0 auto",
                    }}
                  />
                  <Button
                    variant="contained"
                    sx={{
                      background: "#FFB60C",
                      color: "#050505",
                      fontWeight: 700,
                      fontSize: 16,
                      borderRadius: 2,
                      px: 4,
                      py: 1,
                      mt: 2,
                      boxShadow: "none",
                      "&:hover": { background: "#FFB60C" },
                    }}
                    onClick={() => {
                      navigate("/ptag-air/payment");
                    }}
                  >
                    {t('buy')}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>

          {/* Comparison Table Section */}
          <Box
            sx={{
              maxWidth: 600,
              my: 8,
              px: 2,
              mx: "auto",
            }}
          >
            <Typography variant="h6" fontWeight={700} sx={{ textAlign: "left" }}>
              {t('Version')}
            </Typography>
            <Divider sx={{ my: 2 }} />
            <Grid
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                gap: isMobile ? "10%" : "37%",
              }}
            >
              {/* 版本 */}
              <Grid
                item
                xs={6}
                sx={{
                  textAlign: "left",
                  py: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "center",
                  width: 179,
                }}
              >
                <Typography>{t('normal')} - HKD $259</Typography>
                <Typography color="text.secondary" fontSize={14}>
                  —
                </Typography>
                <Typography sx={{ mt: 2 }}>{t('custom')} - HKD $279</Typography>
                <Typography color="text.secondary" fontSize={14}>
                  <TaskAltIcon sx={{ fontSize: 16, mr: 1 }} />
                  {t('namePhotoPhoneNumber')}
                </Typography>
              </Grid>
              <Grid item xs={6} sx={{ textAlign: "left", py: 2, width: 179}}>
                <Typography>{t('normal')} - HKD $199</Typography>
                <Typography color="text.secondary" fontSize={14}>
                  <TaskAltIcon sx={{ fontSize: 16, mr: 1}} />
                  {t('namePhoto')}
                </Typography>
              </Grid>
            </Grid>
          </Box>

          {/* 材質 */}
          <Box
            sx={{
              maxWidth: 600,
              my: 8,
              px: 2,
              mx: "auto",
            }}
          >
            <Typography variant="h6" fontWeight={700} sx={{ textAlign: "left" }}>
              {t('texture')}
            </Typography>
            <Divider sx={{ my: 2 }} />
            <Grid
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                gap: isMobile ? "45%" : "63%",
              }}
            >
              <Grid item xs={6} sx={{width: 32.3}}>
                <Typography>{t('metal')}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>{t('plastic')}</Typography>
              </Grid>
            </Grid>
          </Box>

          {/* 尺寸及重量 */}
          <Box
            sx={{
              maxWidth: 600,
              my: 8,
              px: 2,
              mx: "auto",
            }}
          >
            <Typography variant="h6" fontWeight={700} sx={{ textAlign: "left" }}>
              {t('dimensions&weight')}
            </Typography>
            <Divider sx={{ my: 2 }} />
            <Grid
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                gap: isMobile ? "24%" : "50%"
              }}
            >
              <Grid
                item
                xs={6}
                sx={{
                  textAlign: "center",
                  py: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "space-around",
                  gap: 2,
                  width: 108.52,
                }}
              >
                <Typography>25 {t('mm')} - 7 {t('gram')}</Typography>
                <Typography>30 {t('mm')} - 10 {t('gram')}</Typography>
              </Grid>
              <Grid item xs={6} sx={{ textAlign: "center", py: 2 }}>
                <Typography>25 {t('mm')} - 3 {t('gram')}</Typography>
              </Grid>
            </Grid>
          </Box>

          {/* 顏色 */}
          <Box
            sx={{
              maxWidth: 600,
              my: 8,
              px: 2,
              mx: "auto",
            }}
          >
            <Typography variant="h6" fontWeight={700} sx={{ textAlign: "left" }}>
              {t('color')}
            </Typography>
            <Divider sx={{ my: 2 }} />
            <Grid
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                gap: isMobile ? "38%" : "59%"

              }}
            >
              <Grid
                item
                xs={4}
                sx={{
                  textAlign: "center",
                  py: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-around",
                  gap: 2,
                  width: 60.3,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <img
                    src="/icons/gold.png"
                    alt="gold"
                    style={{ width: 20, height: 20, objectFit: "contain", border: "1px solid black", borderRadius: "10px" }}
                  />
                  <Typography>{t('golden')}</Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <img
                    src="/icons/silver.png"
                    alt="silver"
                    style={{ width: 20, height: 20, objectFit: "contain", border: "1px solid black", borderRadius: "10px" }}
                  />
                  <Typography>{t('silver')}</Typography>
                </Box>
                
              </Grid>
              <Grid item xs={4} sx={{ textAlign: "center", py: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <img
                    src="/icons/white.png"
                    alt="white"
                    style={{ width: 20, height: 20, objectFit: "contain", border: "1px solid black", borderRadius: "10px" }}
                  />
                  <Typography>{t('white')}</Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </>
      )}
      <Footer />
    </Box>
  );
}
